import { createContext, useContext } from "react";

import { Episode } from "@/types/Episode";
import { User } from "@/types/User";

type OnboardingContextType = {
  featuredMention: Episode | null;
  setFeaturedMention: (v: Episode) => void;
  setMissingFeatured: (v: boolean) => void;
  missingFeatured: boolean;
  user: undefined | User;
  setUser: (v: User) => void;
};
const OnboardingContext = createContext<OnboardingContextType>(
  {} as OnboardingContextType
);
export const useOnboardingContext = () => useContext(OnboardingContext);

export default OnboardingContext;
